import script from "./HomeInstagramGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeInstagramGrid.vue?vue&type=script&setup=true&lang=js"

import "./HomeInstagramGrid.vue?vue&type=style&index=0&id=d476deca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d476deca"]])

export default __exports__